export enum FORM_STATUSES {
  FINISHED = 'Finished',
  STARTED = 'Started',
}
